<style>
.fc-event-container a {
  width: 10px !important;
  background: red;
  float:left;
}
</style>
<template>
  <div>
    <b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden">
			<EditModal :allContacts="allContacts"  ref="refEditModal"/>
		</b-modal>
    <b-modal size="xl" hide-footer id="editProjectModal" title="" class="modal-edit-project" @hide="editProjectModalHidden">
      <EditProjectModal ref="refEditProjectModal"/>
    </b-modal>
    <HeaderControls :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' />
    <div class="container-fluid">
      <CalendarView :filterQuery="filterQuery" />
    </div>
  </div>
</template>
<script>
import CalendarView from "../components/deliverables/CalendarView";
import HeaderControls from "../components/common/HeaderControls";
import EditModal from "../components/deliverables/EditModal";
import EditProjectModal from "../components/deliverables/EditProjectModal";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: []
      },
      expandAll: !this.isMobile()
    }
  },
  computed: {
    ...mapGetters(["allCustomFields", 'allUsers', 'allContacts', 'deliverableDetail', 'projectDetail']),
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    CalendarView,
    HeaderControls,
    EditModal,
    EditProjectModal
  },
  created() {
    this.fetchDepartments()
		this.fetchProjects()
    this.fetchAllCustomFields()
		this.fetchUsers()
    this.fetchActiveUsers()
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = false;
			} else if (modalId == "editProjectModal") {
				this.$store.state.deliverables.editProjectModal = false;
			}
      let currentTitle = document.title.match(/\(\d+\)\s/g);
      if(!currentTitle) {
        document.title = process.env.MIX_APP_NAME;
      } else {
        document.title = currentTitle[0] + process.env.MIX_APP_NAME;
      }
		})
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = true;
			}
		})
  },
  methods: {
    ...mapActions(['fetchDepartments', 'fetchProjects', 'fetchAllCustomFields', 'fetchUsers', 'fetchActiveUsers']),
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
		editDeliverableModalHidden() {
			this.$store.commit('setDeliverable', this.deliverableDetail)
		},
		editProjectModalHidden() {
			this.$store.commit('setProject', this.projectDetail)
		},
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
};
</script>